import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from 'react-bootstrap';
import moment from 'moment';

import EventListMonth from '../EventListMonth.jsx';

import '../css/EventListContent.css';

class EventListContent extends Component {
  changeYear(direction) {
    if (direction === 'minus') {
      this.props.changeYearViewDate(moment(this.props.yearViewDate).subtract(1, 'year'));
    } else if (direction === 'plus') {
      this.props.changeYearViewDate(moment(this.props.yearViewDate).add(1, 'year'));
    }
  }

  render() {
    return (
      <div>
        <div className="listHeader">
          <div className="headerLeft">
            <Button
              className="leftArrow"
              bsSize="xsmall"
              onClick={() => this.changeYear('minus')}
            ><Glyphicon glyph="glyphicon glyphicon-triangle-left" /></Button>
          </div>

          <div className="headerMiddle">
            <b>{moment(this.props.yearViewDate).year()}</b>
          </div>

          <div className="headerRight">
            <Button
              className="rightArrow"
              bsSize="xsmall"
              onClick={() => this.changeYear('plus')}
            ><Glyphicon glyph="glyphicon glyphicon-triangle-right" /></Button>
          </div>
        </div>

        <div className="listCheckbox">
          <form>
            <input
              id="forCheckbox"
              type="checkbox"
              onChange={e => this.props.toggleCheckbox(e.target.checked)}
              checked={this.props.isChecked}
            />
            {' '}
            <label htmlFor="forCheckbox">Vain kartalla näkyvät kohteet</label>
          </form>
        </div>

        <div className="listContent">
          <EventListMonth
            yearViewDate={this.props.yearViewDate}
            mapEvents={this.props.mapEvents}
            selectedBbox={this.props.selectedBbox}
            checkboxState={this.props.isChecked}
            changeMapView={this.props.changeMapView}
          />
        </div>
      </div>
    );
  }
}

EventListContent.propTypes = {
  mapEvents: PropTypes.array.isRequired,
  selectedBbox: PropTypes.object.isRequired,
  changeMapView: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
  yearViewDate: PropTypes.object.isRequired,
  changeYearViewDate: PropTypes.func.isRequired
};

export default EventListContent;



// WEBPACK FOOTER //
// ./src/components/eventDetails/EventListContent.jsx